import { useEffect } from 'react';
import { GrabberResizer } from '@sas/react-svg';
import cx from 'classnames';
import { useResizable } from '.';
import { useIsRTL } from '../../locale';
import { createUseTextLocalizer } from '../../locale/createUseTextLocalizer';
import { renderInlineCssVars, useDesignTokens } from '../../theme';
import { Icon } from '../Icon';
import bundle from './NovaComponents-Resizable-gui-icu.properties';
import cn from './Resizable.css.json';
import './Resizable.css';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import { jsx as _jsx } from "react/jsx-runtime";
const useTextLocalizer = createUseTextLocalizer(bundle);
export const Resizer = ({
  tooltip,
  ariaLabel,
  className,
  style,
  resizableElementRef,
  onResize,
  testId,
  onMouseEnter,
  onMouseLeave,
  setIsDragging
}) => {
  const isRTL = useIsRTL();
  const localize = useTextLocalizer();
  const {
    startResize,
    onArrowKeyResize,
    abortResize,
    isDragging
  } = useResizable({
    ref: resizableElementRef,
    onResize
  });
  useEffect(() => {
    setIsDragging?.(isDragging);
  }, [isDragging, setIsDragging]);
  const dt = useDesignTokens();
  // Feature flag for 'New Token Values'
  const isNewTokenValueFlagEnabled = useFeatureFlag('NOVACOMMONS-22288_ThemeModernization_NewTokenValues');
  const tokens = renderInlineCssVars({
    'color-text-label': dt.tokens['color-label-text'],
    'focus-outline': 'calc(-1 * var(--focus-width))',
    ...(!isNewTokenValueFlagEnabled && {
      'focus-outline': 'calc(-1 * var(--focus-width) - 2px)'
    })
  }, 'resizer');
  return /*#__PURE__*/_jsx("div", {
    role: "img",
    tabIndex: 0,
    className: cx(cn.gripIconWrapper, isRTL && cn.gripCursorRtl, className),
    style: style,
    onMouseDown: startResize,
    onKeyDown: onArrowKeyResize,
    onMouseUp: abortResize,
    "data-testid": testId,
    title: tooltip ?? localize('gripIcon.label'),
    "aria-label": ariaLabel ?? localize('gripIcon.aria'),
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    children: /*#__PURE__*/_jsx(Icon, {
      icon: GrabberResizer,
      tooltip: "",
      ariaLabel: "",
      style: tokens
    })
  });
};
//# sourceMappingURL=Resizer.js.map